
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/[locale]/closets",
      function () {
        return require("private-next-pages/[locale]/closets/index.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/[locale]/closets"])
      });
    }
  